import {
  initialState,
  Actions,
  State,
  NEW_WELCOME_CONTENT_SECTION,
  NEW_WELCOME_CONTENT_SECTION_SUCCESS,
  NEW_WELCOME_CONTENT_SECTION_ERROR,
  RESET_NEW_WELCOME_CONTENT_SECTION,
} from "../../types/welcome-content/new-welcome-content-section";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case NEW_WELCOME_CONTENT_SECTION:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case NEW_WELCOME_CONTENT_SECTION_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case NEW_WELCOME_CONTENT_SECTION_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case RESET_NEW_WELCOME_CONTENT_SECTION:
      return initialState;
    default:
      return state;
  }
};

export default reducers;
